import { jsonSchema } from 'ai';
import { zodToJsonSchema } from 'zod-to-json-schema';
export const createAgentInputSchema = (inputSchema) => jsonSchema(
// DL Fork: type-only cast — zodToJsonSchema returns JsonSchema7Type which
// this toolchain does not widen to JSONSchema7 automatically
zodToJsonSchema(inputSchema, {
    $refStrategy: 'root',
    target: 'jsonSchema7',
}), {
    validate: (value) => {
        const result = inputSchema.safeParse(value);
        if (result.success) {
            return { success: true, value: result.data };
        }
        return { success: false, error: result.error };
    },
});
//# sourceMappingURL=agentInputSchema.js.map